import styled from "styled-components";

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`;

export const ColBox = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 32px;

  @media (min-width: 768px){
    justify-content: space-between;
  }
`

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  gap: 32px;
  width: 100%;

  @media (min-width: 768px){
    max-width:570px ;
  }

  img{
    width: 156px;
  }

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;

    @media (min-width: 850px){
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 2px;
    }
  }

  p{
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1px;
  }

  button{
    height: 40px;
    opacity: 1;
    border-radius: 8px;
    border-width: 1px;
    padding-top: 8px;
    padding-right: 16px;
    padding-bottom: 8px;
    padding-left: 16px;
    gap: 8px;
    
    @media (min-width: 768px){
      width: 185px;
    }
  }
`
export const RightCol = styled.div`
  display: none;

  @media (min-width: 768px){
    display: flex;
    align-items: center;

    img{
      width: 544px;
    }
  }
`